import React from 'react';
import './styles/mobilelayout.css';

export interface MobileLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  showBottomPadding?: boolean;
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  header,
  footer,
  showBottomPadding = false,
}) => {
  return (
    <div className="mobile-layout">
      {header && <div className="mobile-layout__header">{header}</div>}
      
      <main className={`mobile-layout__content ${showBottomPadding ? 'mobile-layout__content--with-footer' : ''}`}>
        {children}
      </main>
      
      {footer && <div className="mobile-layout__footer">{footer}</div>}
    </div>
  );
};